module.exports = __webpack_public_path__ + "static/img/logo.2f55824d.png";